export const formatRomaneio = (code) => {
    if (!code) return "";
    if (code.length == 11) {
        const part1 = code.slice(4, 5);
        const part2 = code.slice(5, 8);
        const part3 = code.slice(8, 11);

        return `${part1}.${part2}.${part3}`
    } else if (code.length == 15) {
        const year = code.slice(4, 8);
        const month = code.slice(8, 10);
        const day = code.slice(10, 12);
        const sequence = code.slice(12);
        return `${year}/${month}/${day} ${sequence}`;
    }else{
        return code;
    }

};